import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="fixed inset-0 bg-accent-sand flex items-center justify-center px-4 z-50">
      <div className="max-w-2xl w-full text-center">
        {/* 404 Number */}
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-secondary-500 leading-none">404</h1>
          <div className="mt-4 w-24 h-1 bg-secondary-500 mx-auto"></div>
        </div>

        {/* Error Message */}
        <div className="mb-8">
          <h2 className="text-3xl font-bold text-text-heading mb-4">Page Not Found</h2>
          <p className="text-lg text-text-description max-w-md mx-auto">
            Oops! The page you're looking for doesn't exist. It might have been moved, deleted, or the URL might be incorrect.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={() => navigate(-1)}
            className="px-6 py-3 bg-white border border-accent-taupe rounded-lg text-text-heading font-medium hover:bg-accent-sand transition-colors flex items-center gap-2"
          >
            <i className="fas fa-arrow-left"></i>
            <span>Go Back</span>
          </button>
          <Link
            to="/"
            className="px-6 py-3 bg-secondary-500 text-white rounded-lg font-medium hover:bg-secondary-600 transition-colors flex items-center gap-2"
          >
            <i className="fas fa-home"></i>
            <span>Go to Dashboard</span>
          </Link>
        </div>

        {/* Helpful Links */}
        <div className="mt-12 pt-8 border-t border-accent-taupe">
          <p className="text-sm text-text-description mb-4">You might be looking for:</p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/gallery" className="text-secondary-600 hover:text-secondary-700 text-sm font-medium">
              <i className="fas fa-images mr-1"></i>
              My Gallery
            </Link>
            <Link to="/credit-history" className="text-secondary-600 hover:text-secondary-700 text-sm font-medium">
              <i className="fas fa-receipt mr-1"></i>
              Credit History
            </Link>
            <Link to="/subscription" className="text-secondary-600 hover:text-secondary-700 text-sm font-medium">
              <i className="fas fa-crown mr-1"></i>
              Subscription
            </Link>
            <Link to="/profile" className="text-secondary-600 hover:text-secondary-700 text-sm font-medium">
              <i className="fas fa-user mr-1"></i>
              Profile
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
